import translate from '../../../../../utils/translations';

export default function labels(translations, {minStayLength}) {
    return {
        availableNoticePropTitle: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.datesAvailable'
        ),
        checkInDateInPast: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.checkInDateInPast'
        ),
        checkoutAfterCheckin: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.checkoutAfterCheckin'
        ),
        dateNotAvailable: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.dateNotAvailable'
        ),
        dateNotAvailableForCheckin: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.dateNotAvailableForCheckin'
        ),
        dateNotAvailableForCheckout: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.dateNotAvailableForCheckout'
        ),
        datesUnavailable: translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'datepicker.datesUnavailable'
        ),
        directionsLabel: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.selectNewDates'
        ),
        inputLabel1: translate(
            translations,
            'traveler/listing',
            'messages',
            'checkIn'
        ),
        inputLabel2: translate(
            translations,
            'traveler/listing',
            'messages',
            'checkOut'
        ),
        minStayLong: translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'datepicker.minStayLong',
            {0: minStayLength}
        ),
        minStayVaries: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.minStayVaries'
        ),
        noAvailableDates: translate(
            translations,
            'traveler/listing',
            'messages',
            'datepicker.noAvailableDates'
        ),
    };
}
